import React from 'react';
import {
  Building2, Wallet, Wrench, FileText, BarChart3, Users,
  ArrowUpRight, Sparkles,
} from 'lucide-react';
import T from '@/components/landing/copy';
import { tt, Section, Eyebrow } from '@/components/landing/atoms';

// ─────────────────────────────────────────────────────────────────────────────
// OPERATIONS MODULES
// Real estate first. AI embedded in each module — not the headline.
// Pattern: Buildium "Run rent collection, accounting, maintenance, screening".
// ─────────────────────────────────────────────────────────────────────────────

const ICONS = { Building2, Wallet, Wrench, FileText, BarChart3, Users };

export default function OperationsModules({ lang, navigate }) {
  const isAr = lang === 'ar';
  return (
    <Section id="modules" className="py-20 md:py-28">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <Eyebrow>{tt(T.modules.eyebrow, lang)}</Eyebrow>
          <h2 className="mt-5 reva-display-light text-3xl sm:text-5xl tracking-[-0.02em] leading-[1.05] max-w-[22ch]">
            {tt(T.modules.titleA, lang)}{' '}
            <span className="reva-signal-text-light">{tt(T.modules.titleB, lang)}</span>
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-[15px] leading-[1.6] text-[#4A5263] max-w-md">
            {tt(T.modules.sub, lang)}
          </p>
        </div>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {T.modules.items.map((m, i) => {
          const Icon = ICONS[m.icon] || Building2;
          return (
            <button
              key={i}
              type="button"
              onClick={() => m.to && navigate?.(m.to)}
              className="reva-module-card text-start group"
              data-testid={`reva-module-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="reva-module-card__icon">
                  <Icon className="h-5 w-5 text-[#00734A]" strokeWidth={1.7} />
                </div>
                {m.aiEmbedded && (
                  <span className="inline-flex items-center gap-1 text-[10px] reva-mono uppercase tracking-[0.14em] text-[#00734A] bg-[rgba(0,168,107,0.08)] border border-[rgba(0,168,107,0.20)] px-1.5 py-0.5 rounded-full">
                    <Sparkles className="h-2.5 w-2.5" />
                    {isAr ? 'ذكاء مدمج' : 'AI · built-in'}
                  </span>
                )}
              </div>
              <h3 className="mt-5 text-[17px] font-semibold text-[#0E1320] tracking-tight">{tt(m.title, lang)}</h3>
              <p className="mt-2 text-[13.5px] leading-[1.55] text-[#4A5263]">{tt(m.desc, lang)}</p>
              <ul className="mt-4 space-y-1.5">
                {(m.points || []).map((p, j) => (
                  <li key={j} className="text-[12.5px] text-[#2A3340] flex gap-2">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-[color:var(--reva-signal)] shrink-0" />
                    <span>{tt(p, lang)}</span>
                  </li>
                ))}
              </ul>
              {m.to && (
                <div className="mt-5 inline-flex items-center gap-1 text-[12px] font-medium text-[#00734A] group-hover:gap-2 transition-all">
                  {isAr ? 'استكشف' : 'Explore'} <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </Section>
  );
}
